import React from "react";
import InputField from "../../../Components/InputField";
import { Box, Card } from "@mui/material";
import CustomTypography from "../../../Components/Typography";
import muiStyles from "../styles/muiStyles";
import { useTranslation } from "react-i18next";
import { useFormikContext } from "formik";
import PhoneNumberInput from "../../../Components/PhoneNumberInput";

const ContactDetails = ({ disableFields }) => {
  const { cardStyles, inputGridStyles } = muiStyles;
  const { t } = useTranslation("page-community-settings");

  const { handleChange, handleBlur, values, touched, errors, setFieldValue } =
    useFormikContext();

  return (
    <Card sx={{ ...cardStyles, overflow: "unset" }}>
      <CustomTypography type="subheading">
        {t("community_manager_details.title")}
      </CustomTypography>

      <Box
        sx={{
          ...inputGridStyles,
          gridTemplateColumns: {
            xs: "1fr",
            sm: "1fr 1fr",
            md: "1fr 1fr 1fr",
          },
          pt: "32px",
        }}
      >
        <InputField
          name="manager_full_name"
          label={t("community_manager_details.manager_full_name")}
          value={values.manager_full_name}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder={t("community_manager_details.manager_full_name")}
          disabled
          error={touched.manager_full_name && Boolean(errors.manager_full_name)}
          helperText={touched.manager_full_name && errors.manager_full_name}
        />

        <PhoneNumberInput
          wrapperId="community-settings-phone-input"
          label={t("community_manager_details.phone_number")}
          disabled={disableFields}
          prefixName="manager_phone_prefix"
          phoneNumberName="manager_phone_number"
          prefixValue={values.manager_phone_prefix}
          phoneNumber={values.manager_phone_number}
          phoneNumberPlaceholder={t("community_manager_details.phone_number")}
          setFieldValue={setFieldValue}
          handleChange={handleChange}
          handleBlur={handleBlur}
          touched={touched}
          errors={errors}
        />

        <InputField
          name="manager_email"
          type="email"
          label={t("community_manager_details.manager_email")}
          value={values.manager_email}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder={t("community_manager_details.manager_email")}
          disabled={disableFields}
          error={touched.manager_email && Boolean(errors.manager_email)}
          helperText={touched.manager_email && errors.manager_email}
        />
      </Box>
    </Card>
  );
};

export default ContactDetails;
